export function getEvent(state) {
    return state.selects.event;
}